//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default {
		data() {
			return {
				pager: {
					page: '1',
					count: '1',
				},
				page: '1',
				count: '10',
				listArrs: Array,
			}
		},
		mounted() {
			this.getCoupon()
		},
		methods: {
			pageNum(n, par) {
				if(par == 'up') {
					if(n > 1) {
						n = n - 1;
						this.page = n
						this.count = '10';
						this.getCoupon();
					}
				} else if(par == 'down') {
					if(n < this.pager.count) {
						n = parseInt(n) + 1;
						this.page = n
						this.count = '10';
						this.getCoupon();
					}
				}
			},

			getCoupon() {
				let data = 'cmd=yhq_list&page=' + this.page + '&count=' + this.count+'&yhq_type=onuse';
				this.$http.post('https://api.abeiyun.com/www/caiwu.php', data).then(({data}) => {
					if(data.response == 200){
            this.listArrs = data.data.content;
            console.log(this.listArrs)
            this.pager.count = data.data.allpage;
            this.pager.page = data.data.curpage
          }else {

          }
				})
			}

		}
	}



// WEBPACK FOOTER //
// ./src/components/finance/cashcoupon.vue